import React, { 
    Component, 
    useEffect, 
    useState 
} from 'react';
import { 
    withTranslation, 
    Trans, 
    withNamespaces 
} from 'react-i18next';
// import { withStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';

import '../css/common-toaster.css';


const CommonCustomToaster = ({ headContent, success }) => {

  return(
    <div className="ctoast-notification" >
      <div 
        className="ctoast-card"
      >
        <div className="ctoast-progress">
          <span className={success ? 'succs' : 'dng'}></span>
        </div>
        <div className={`ctoast-heading ${success ? 'hd-succs' : 'hd-dng' }`}>
          <p className="fh4" style={{color: 'black'}}><Trans>{headContent}</Trans></p>
        </div>
      </div>
    </div>
  );

}

export default withTranslation()(CommonCustomToaster);